import React from "react";
import PurchaseServiceUser from "../../../../components/UserServicePlanManagement/PurchaseServiceUser/PurchaseServiceUser";

const PurchasePlansHistory = (props) => {
    const { userId } = props;

    return (
        <PurchaseServiceUser userId={userId} />

    )
}
export default PurchasePlansHistory;